/*
 * Fixed position footer
 * ----------------------------------------------- */
import { isMobile } from "./isMobile";

jQuery(window).on("load scroll", function () {
  if (isMobile()) {
    var $fixedBanner = $(".banner-fixed");
    var $fv = $(".section-fv");
    var scrollTop = $(window).scrollTop();
    if ($fv) {
      var $fvHeight = $fv.height();
    }

    if (scrollTop > $fvHeight) {
      $fixedBanner.addClass("active");
    } else {
      $fixedBanner.removeClass("active");
    }

    if (scrollTop > 0) {
      $(".navbar .navbar-brand").addClass("hidden");
    } else {
      $(".navbar .navbar-brand").removeClass("hidden");
    }
  }
});
